<template>
  <div class="myComponent">
    <iframe
      v-show="isShow"
      width="100%"
      height="100%"
      :src="resouceIframe"
      ref="resouceIframe"
      frameborder="0"
    ></iframe>
    <div   v-show="!isShow" style="height: 100px;line-height: 100px;color: #999999;text-align: center">
      您未开通答案权限
    </div>
  </div>
</template>

<script>
  /**
   *    create by wjl on 2021.11.16
   *     把之前的答案对比方式，改成了在资源库展示，
   *     维护起来更方便
   *     props中，除了preview，都是必传参数
   *    试题来源于资源库，再回归去资源库。
   */
  import * as api from '@/api/courseApi'
  export default {
    name: "myComponent",
    props: {
      myId: { // 试题id
        type: [String, Number],
        default: ''
      },
      catalogId: { // 目录id
        type: [String, Number],
        default: ''
      },
      type: { // 课程类型，来区别评分的规则。1：书证融通，2：单项，3：综合，
        type: [String, Number],
        default: ''
      },
      companyCode: { //  账套公司
        type: [String, Number],
        default: ''
      },
      refresh: { // 刷新页面
        type: [Boolean, Number],
        default: 0
      },
      optObject: { // 参数对象  classId courseId
        type: Object,
        default: () => {
        }
      },
      preview: {  // 测试页面调用，不走答案对比的接口
        type: Boolean,
        default: false
      },
      isShow: {  //是否展示DOM
        type: Boolean,
        default: false
      },
    },
    components: {},
    data() {
      return {
        resouceIframe: '',  // 引入资源库
      }
    },
    watch: {
      'refresh': function (val) {
        this.init();
      },
      'companyCode': function (val) {
        if (val)  this.openResourceIframe()
      }
    },
    created() {},
    mounted() {
        this.openResourceIframe()
      let that = this;
      window.addEventListener("message", (message) => {
        // 获取从资源库传来的评分内容
        if (message.data && message.data.form === 'resource') {
          that.$emit('taskSubmit', message.data.bool, message.data.rolesWeight, message.data.ease)
        }
      }, false);
    },
    methods: {
      init() {
        // 初始化iframe。时间戳是唯一标识
        let iframe = this.$refs.resouceIframe;
        if (iframe && iframe.contentWindow) {
          let iframeWin = iframe.contentWindow; // process.env.RESOURSE_URL
          // iframeWin.postMessage({refresh: true}, 'http://localhost:8080');
          iframeWin.postMessage({refresh: true}, process.env.RESOURSE_URL);
        }
      },
      openResourceIframe() {
        // process.env.RESOURSE_URL
        // this.resouceIframe = 'http://localhost:8080/#/?type=gxzxpf&token=' + localStorage.getItem('Authorization') +
        this.resouceIframe = process.env.RESOURSE_URL + '/#/?type=gxzxpf&token=' + localStorage.getItem('Authorization') +
          "&id=" + this.myId +
          "&companyCode=" + this.companyCode +
          "&preview=" + this.preview +
          "&catalogId=" + this.catalogId +
          "&courseId=" + this.optObject.id +
          "&classId=" + this.optObject.classId +
          "&labelId=" + sessionStorage.getItem('productFlag') +
          "&userType=" + sessionStorage.getItem('userType') +
          "&userId=" + sessionStorage.getItem('userId') +
          "&username=" + sessionStorage.getItem('userName') +
          "&nickname=" + sessionStorage.getItem('loginName') +
          "&deptName=" + sessionStorage.getItem('deptName') +
          "&deptId=" + sessionStorage.getItem('deptId') +
          "&cType=" + this.type;
      },
    }

  }
</script>

<style scoped lang="scss">
  .myComponent {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/myComponent.vue